<script>
    import { page } from '$app/stores';
    import Button from "$lib/atoms/Button.svelte";
    import { ArrowRight } from "lucide-svelte";
    import '../../app.css';
    import BlogArticleItem from "./BlogArticleItem.svelte";
    import { t } from '$lib/i18n.js';

    // This section will fetch the articles by an API. At the moment it's not implemented. Implement a mock API or use a static list of articles.
    // import { getArticles } from "$lib/api/articles"; // Example API function
    // let articles = [];
    // getArticles().then(data => {
    //     articles = data;
    // });
    // For now, we will use a static list of articles.
    let articles = [
        {
            href: "https://blog.auting.it/in-evidenza/5-road-trip-indimenticabili-in-sardegna-con-il-car-sharing-di-auting/",
            image: "https://blog.auting.it/wp-content/uploads/2024/07/Capriccioli_auting-1.jpg",
            title: "5 idee per un Road Trip Indimenticabile in Sardegna"
        },
        {
            href: "https://blog.auting.it/mobilita/abbiamo-le-idee-chiare-quando-parliamo-di-car-sharing/",
            image: "https://blog.auting.it/wp-content/uploads/2024/03/carsharing-scaled.jpg",
            title: "Car sharing, una parola per tante soluzioni"
        },
        {
            href: "https://blog.auting.it/in-evidenza/gita-in-car-sharing-le-mete-piu-rilassanti-nei-dintorni-di-milano/",
            image: "https://blog.auting.it/wp-content/uploads/2024/10/lago_milano.png",
            title: "Gita in car sharing: le mete più rilassanti nei dintorni di Milano"
        }
    ];
</script>

{#if $page.params.lang === 'it'}
<section>
    <div class="row">
        <h3>{$t('components.blog.title')}</h3>
    </div>
    <div class="row">
        {#each articles as article}
            <BlogArticleItem
                href={article.href}
                image={article.image}
                title={article.title}
            />
        {/each}
    </div>
</section>
{/if}

<style>

    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        gap: 0px;
        padding: 1rem 2rem;
        padding-top: 100px;
        padding-bottom: 100px;
    }

    .row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        max-width: var(--max-width);
        width: 100%;
        margin: 0 auto;
        padding-top: 1rem;
		
    }

    h3 {
        font-family: var(--font-body);
        color: var(--on-surface);
        margin:0;
        padding:0;
    }

    @media (max-width: 768px) {
        section {
            padding: 1rem;
        }
        .row {
            flex-direction: column;
            align-items: stretch;
            padding-top: 1rem;
        }
    }
</style>
